















import Vue from 'vue';
import AcceptedCookieRevoke from '@/components/acceptedcookierevoke/AcceptedCookieRevoke.vue';
import UnsubscribeNewsletter from '@/components/footer/subcomponent/UnsubscribeNewsletter.vue';

export default Vue.extend({
  name: `FooterLink`,
  components: { AcceptedCookieRevoke, UnsubscribeNewsletter },
  props: {
    delegate: {
      default: false,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    target: {
      default: ``,
      type: String,
    },
  },
});
